export default "__VITE_ASSET__9ffb5634__"